import { render, staticRenderFns } from "./MatrixScale.vue?vue&type=template&id=0940c748&scoped=true"
import script from "./MatrixScale.vue?vue&type=script&lang=js"
export * from "./MatrixScale.vue?vue&type=script&lang=js"
import style0 from "./MatrixScale.vue?vue&type=style&index=0&id=0940c748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0940c748",
  null
  
)

export default component.exports